import { render, staticRenderFns } from "./BehaviorStastic.vue?vue&type=template&id=49f3bb49"
import script from "./BehaviorStastic.vue?vue&type=script&lang=js"
export * from "./BehaviorStastic.vue?vue&type=script&lang=js"
import style0 from "./BehaviorStastic.vue?vue&type=style&index=0&id=49f3bb49&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports